async function getDataToFilterAdvertisements() {
  const responsePromise = await fetch('/advertisementsAmount.json');

  return await responsePromise.json();
}

export default getDataToFilterAdvertisements;
